import { css } from 'styled-components';

// Standard screen-reader-only pattern: the element stays in the
// accessibility tree but is not visible on screen.
export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;
